var _path, _path2, _g, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLogoWhite = function SvgLogoWhite(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 108,
    height: 42,
    fill: "none",
    viewBox: "0 0 108 42",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E31B23",
    d: "M106.563.586H.523v40.826h106.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 32,
    height: 42,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.76 41.414 31.978.586H.522v40.828z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "m26.358-11.462-41.476 19.34L6.137 53.46l41.476-19.34z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.687 22.434c0 5.837-5.122 10.636-10.566 10.636-4.585 0-7.844-2.937-7.844-7.09 0-5.838 5.12-10.637 10.567-10.637 4.584 0 7.843 2.938 7.843 7.09m-7.736-4.62c-3.007 0-4.584 7.63-4.584 10.28 0 2.148.86 2.507 1.612 2.507 3.044 0 4.619-7.629 4.619-10.277 0-2.148-.86-2.507-1.647-2.507M61.126 33.073c-4.726 0-7.843-1.899-7.843-4.37 0-1.754 1.29-2.866 2.865-2.866 1.933 0 2.793 1.254 2.793 2.472 0 .645-.214 1.398-.787 2.04.43.215 1.18.574 2.506.574 1.861 0 2.651-.967 2.651-2.113 0-1.36-1.612-2.04-3.152-2.793-2.544-1.219-4.798-2.4-4.798-4.978 0-3.76 3.904-5.696 7.843-5.696 4.333 0 7.163 1.933 7.163 4.226 0 1.612-1.288 2.686-2.758 2.686-2.04 0-2.9-1.36-2.9-2.437 0-.822.252-1.433.645-1.899-.286-.18-.932-.43-1.791-.43-1.754 0-2.651 1-2.651 2.042 0 1.468 1.826 2.113 4.046 3.26 1.826.931 4.049 2.04 4.049 4.618 0 3.905-3.797 5.659-7.878 5.659M78.245 32.821h6.017c3.007-12.069 5.543-13.252 6.796-13.252.68 0 1.074.359 1.074.966 0 1.934-2.4 6.052-2.4 9.025 0 1.97 1.326 3.51 3.833 3.51q.638-.002 1.237-.144l3.213-12.19a8.3 8.3 0 0 0 .21-1.743c0-2.327-1.613-3.652-3.798-3.652-2.865 0-5.696 1.898-8.237 7.522l-.286-.108c.5-1.933.573-3.08.573-3.976 0-2.292-1.288-3.438-2.938-3.438q-.349 0-.683.045l-4.61 17.433zM52.107 13.338c-1.754 0-3.044-1.146-3.044-2.973A3.695 3.695 0 0 1 52.86 6.71c1.754 0 3.044 1.146 3.044 2.972 0 1.685-1.325 3.653-3.797 3.653M49.012 33.073c.426 0 .838-.051 1.234-.145l3.214-12.19a8.5 8.5 0 0 0 .209-1.742c0-1.05-.33-1.893-.89-2.504q-.057-.06-.115-.118-.046-.049-.093-.094c-.643-.591-1.561-.937-2.64-.937h-.056999999999999995a5.6 5.6 0 0 0-1.518.228l-3.152 11.894-.064.236h.005c-.16.63-.26 1.205-.26 1.682 0 2.255 1.647 3.687 3.977 3.687h.155zM77.595 13.338c-1.754 0-3.045-1.146-3.045-2.973a3.695 3.695 0 0 1 3.797-3.655c1.754 0 3.045 1.146 3.045 2.972 0 1.685-1.326 3.653-3.797 3.653M74.497 33.073c.425 0 .838-.051 1.234-.145l3.21-12.19a8.3 8.3 0 0 0 .21-1.742c0-1.05-.33-1.893-.89-2.504a2 2 0 0 0-.115-.118q-.047-.049-.093-.094c-.643-.591-1.561-.937-2.64-.937h-.056999999999999995a5.6 5.6 0 0 0-1.518.228l-3.152 11.894-.064.236h.005c-.16.63-.262 1.205-.262 1.682 0 2.255 1.647 3.687 3.976 3.687h.156zM22.255 33.073 31.93.743A7 7 0 0 0 30.602.61c-2.518 0-5.203 1.245-5.72 3.007l-5.715 21.567h-.39l-.87-10.138c-.11-1.028-.49-1.874-1.077-2.514-.046-.051-.097-.1-.145-.15q-.058-.058-.118-.116c-.787-.725-1.909-1.154-3.224-1.17H8.866L10.7 26.962c.447 3.355 3.516 6.11 7.661 6.11z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M107.085 41.936H0V.064h107.085v41.872M1.045 40.892H106.04V1.108H1.044v39.784"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: -4.748,
    x2: 36.727,
    y1: 30.185,
    y2: 10.845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D71920"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#D0171E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#BE1319"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A10D11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#780507"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E0000"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLogoWhite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logo_white.088de1fedb2c7a106e3edc7b67df2bbf.svg";